// System
import { useEffect } from 'react';
import { MenuItem, Stack } from '@mui/material';
// Components
import { AtLocator } from '@Components/shared/locators/AtLocator';
// Hooks
import { useFormContext } from 'react-hook-form';
import { RHFSelect, RHFTextField } from '@Components/hook-form';
import { useUpdateMinesProviderConfig } from '@Modal/hooks/providers/useUpdateMinesProviderConfig';
// Styles
import Styles from './UpdateMinesProviderConfigContent.module.scss';

export const UpdateMinesProviderConfigContent = () => {
  const { selectedMinesProviderConfig } = useUpdateMinesProviderConfig();
  const { setValue } = useFormContext();

  useEffect(() => {
    if (selectedMinesProviderConfig) {
      setValue('maxWin', selectedMinesProviderConfig.maxWin);
      setValue('defaultBet', selectedMinesProviderConfig.defaultBet);
      setValue('isRoundable', selectedMinesProviderConfig.isRoundable);
      setValue('minBet', selectedMinesProviderConfig.minBet);
      setValue('maxBet', selectedMinesProviderConfig.maxBet);
      setValue('currency', selectedMinesProviderConfig.currency);
    }
  }, [selectedMinesProviderConfig, setValue]);

  return (
    <Stack className={Styles.UpdateMinesProviderConfigContent}>
      <AtLocator type="text-field" name="currency" key="currency">
        <RHFTextField name="currency" label="Currency" />
      </AtLocator>
      <AtLocator type="text-field" name="maxWin" key="maxWin">
        <RHFTextField name="maxWin" label="Max win" />
      </AtLocator>
      <AtLocator type="text-field" name="defaultBet" key="defaultBet">
        <RHFTextField name="defaultBet" label="Default bet" />
      </AtLocator>
      <RHFSelect
        label="Is roundable?"
        name="isRoundable"
        variant="outlined"
        sx={{ width: '100%', marginTop: '6px', marginBottom: '15px' }}
      >
        <MenuItem value="true">True</MenuItem>
        <MenuItem value="false">False</MenuItem>
      </RHFSelect>
      <AtLocator type="text-field" name="minBet" key="minBet">
        <RHFTextField name="minBet" label="Min bet" />
      </AtLocator>
      <AtLocator type="text-field" name="maxBet" key="maxBet">
        <RHFTextField name="maxBet" label="Max bet" />
      </AtLocator>
    </Stack>
  );
};
